import { DocumentLink } from "./common/DocumentLink";
import {
  hasPlayerRankingResults,
  sortPlayersForRankingDisplay,
} from "@/helper/playerRanking";
import { LeaguePlayerWithTeam } from "../models/LeaguePlayer";
import { PlayerImage, TeamImage } from "./common/Images";
import { NoItems } from "./common/NoItems";

interface PlayerRankingTableProps {
  players: LeaguePlayerWithTeam[];
}
export function PlayerRankingTable({ players }: PlayerRankingTableProps) {
  if (players.length === 0) return <NoItems />;
  const sortedPlayers = sortPlayersForRankingDisplay(players);
  const usePositionAsRank = !hasPlayerRankingResults(sortedPlayers);
  return (
    <div className="table_scrollable max-w-[900px]">
      <table>
        <tbody>
          <tr className="table-header row_item break-words">
            <th className="text-center w-4">Rang</th>
            <th className="w-4">Club</th>
            <th className=" w-4">Name</th>
            <th className="text-center w-4">+/-</th>
          </tr>
          {sortedPlayers.map((p, index) => (
            <PlayerTableCard
              player={p}
              rank={usePositionAsRank ? index + 1 : p.rank}
              key={p.id}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}

interface PlayerTableCardProps {
  player: LeaguePlayerWithTeam;
  rank: number;
}
function PlayerTableCard({ player, rank }: PlayerTableCardProps) {
  return (
    <tr>
      <td>
        <div className="text-center">{rank}</div>
      </td>
      <td>
        <div>
          <TeamImage
            team={player.seasonPlayer.seasonTeam}
            contain={false}
            size="md"
            className="shrink-0"
          />
        </div>
      </td>
      <td>
        <DocumentLink
          className="flex gap-4"
          href={`/bundesliga/players/${player.id}`}
          title={`${player.seasonPlayer.firstName} ${player.seasonPlayer.lastName}`}
        >
          <PlayerImage player={player.seasonPlayer} size="sm" />
          <div>{player.seasonPlayer.lastName}</div>
          <div>{player.seasonPlayer.firstName}</div>
        </DocumentLink>
      </td>
      <td className="text-center">{player.gameDifference}</td>
    </tr>
  );
}
